<div class="row">
  <div class="col-md-6">
    <table class="simple-form">
  
      <tr>
        <th><label for="bankTransferMethod">Bank Transfer Method</label></th>
        <td>
          <div class="form-group">
            <app-dropdown-input #bankTransferMethodSelect id="bankTransferMethod" [options]="bankTransferMethods"
              [parentForm]="paymentInfoForm" name="bankTransferMethod"
              [disabled]="paymentInfoForm.get('bankTransferMethod').disabled"
              placeholder="Select Preferred Bank Transfer Method..."></app-dropdown-input>
          </div>
        </td>
      </tr>
  
      <tr>
        <th><label for="defaultPaymentMethod">Default Payment Method</label></th>
        <td>
          <div class="form-group">
            <app-dropdown-input #defaultPaymentMethodSelect id="defaultPaymentMethod" [options]="defaultPaymentMethods"
              [parentForm]="paymentInfoForm" name="defaultPaymentMethod"
              placeholder="Select Default Payment Method..."></app-dropdown-input>
          </div>
        </td>
      </tr>
  
    </table>
  </div>
  
  <div class="col-md-6" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails)">
  
    <table class="bank-fee-covers bottom-separator">
      <tr>
        <th><label class="separator-label">Bank Fee Covers</label></th>
      </tr>
      <tr>
        <th><label for="bankCoverFeeCurrency">Currency</label></th>
        <td>
          <div class="form-group">
            <app-dropdown-input #bankCoverFeeCurrencySelect id="bankCoverFeeCurrency" [options]="currencies"
              [disabled]="paymentInfoForm.get('bankCoverFeeCurrency').disabled" [parentForm]="paymentInfoForm"
              name="bankCoverFeeCurrency" placeholder="Select currency">
            </app-dropdown-input>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="initial-bank-fee-cover">
            <p>Add <input formControlName="initialBankCoverFee" type="number">
              <strong>{{this.paymentInfoForm.get('bankCoverFeeCurrency').value}}</strong> to each bank transfer.
            </p>
            <button class="btn btn-primary" (click)="loadBankCoverFeeComponent()"
              *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">+</button>
          </div>
        </td>
      </tr>
  
      <tr>
        <td colspan="2">
          <div class="other-bank-fee-covers">
            <div class="fee" *ngFor="let fee of bankFeeCoverData">
              <patient-bank-cover-fee [data]="fee" [currency]="this.paymentInfoForm.get('bankCoverFeeCurrency').value"
                (removeComponentEmitter)="removeBankFeeCoverComponent($event)"
                (componentDataEmitter)="populateBankCoverFeeData($event)"></patient-bank-cover-fee>
            </div>
          </div>
        </td>
      </tr>
  
    </table>
  </div>
</div>